import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Button, FormControl, Table, Spinner, Modal, Dropdown } from "react-bootstrap";
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_GetReport } from "../../store/Functions";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const PageList_PointsEntry = () => {
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [DetailArr, setDetailArr] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0], 
    toDate: new Date().toISOString().split('T')[0]    
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rtPage_Add = "/AddMCQH";
  const rtPage_Edit = "/EditMCQH";
  const breadCrumbTitle = "Points Data";
  const breadcrumbItem = "Points Data";
  const API_URL1 = "GetPointsEntry/0/token";
  const API_URL2 = "MixedStockReport/0/token";
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/VoucherLData`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      let vformData = new FormData();

      vformData.append("F_PumpMaster", obj.uid);
      vformData.append("FromDate", formData.fromDate);
      vformData.append("ToDate", formData.toDate);

      Fn_GetReport(dispatch, setGridData, "tenderData", API_URL1, { arguList: { id: 0, formData: vformData } }, true);

      setLoading(false);
    };

    fetchData();
  }, [dispatch, API_URL1, formData]);

  const btnAddOnClick = () => {
    navigate(rtPage_Add, { state: { Id: 0 } });
  };

  const btnEditOnClick = (row) => {
    Fn_FillListData(dispatch, setDetailArr, "gridData", API_URL + "/Id/"+row.Id);
    setShowModal(true);
  };

  const data = useMemo(() => {
    return gridData;
  }, [gridData]);

  const columns = useMemo(
    () => [
      {
        Header: "PumpName",
        accessor: "PumpName",
      },
      {
        Header: "PointName",
        accessor: "PointName",
      },
      {
        Header: "Worker",
        accessor: "Worker",
      },
      {
        Header: "Reading1",
        accessor: "Reading1",
      },
      {
        Header: "Reading2",
        accessor: "Reading2",
      },
      {
        Header: "NetReading",
        accessor: "NetReading",
      },
      {
        Header: "DateOfCreation",
        accessor: "DateOfCreation",
      },
      {
        Header: "FuelRate",
        accessor: "FuelRate",
      },
      {
        Header: "OilSaleAmount",
        accessor: "OilSaleAmount",
      },
      {
        Header: "TotalSales",
        accessor: "TotalSales",
      },
      {
        Header: "CashCollection",
        accessor: "CashCollection",
      },
      {
        Header: "UPICollection",
        accessor: "UPICollection",
      },
      {
        Header: "CreditBalance",
        accessor: "CreditBalance",
      },
      {
        Header: "DebitBalance",
        accessor: "DebitBalance",
      },
      {
        Header: "NetCollection",
        accessor: "NetCollection",
      },
      {
        Header: "Open Detail",
        Cell: ({ row }) => (
          <Button
            variant="success"
            size="sm"
            onClick={() => btnEditOnClick(row.original)}
          >
            Open
          </Button>
        ),
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={breadCrumbTitle} breadcrumbItem={breadcrumbItem} />

        <Row className="mb-2">
          <Col md="3">
            <FormControl
              type="text"
              placeholder="Search"
              value={globalFilter || ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              className="mb-2"
            />
          </Col>
        </Row>

        <Table {...getTableProps()} responsive bordered striped>
          <thead>
            {headerGroups.map((headerGroup, headerGroupIndex) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroupIndex}>
                {headerGroup.headers.map((column, columnIndex) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={columnIndex}
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, rowIndex) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={rowIndex}>
                  {row.cells.map((cell, cellIndex) => (
                    <td {...cell.getCellProps()} key={cellIndex}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Row className="mt-2">
          <Col>
            <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </Button>{" "}
            <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
              {"<"}
            </Button>{" "}
            <Button onClick={() => nextPage()} disabled={!canNextPage}>
              {">"}
            </Button>{" "}
            <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
              {">>"}
            </Button>{" "}
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <span>
              | Go to page:{" "}
              <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
                style={{ width: "50px" }}
              />
            </span>
            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              style={{ marginLeft: "10px" }}
            >
              {[5, 10, 20, 30, 40].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        </Row>
      </Container>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>Detailed Data</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {DetailArr ? (
      <Table responsive bordered striped>
        <thead>
          <tr>
            
            <th>LedgerNameCr</th>
            <th>LedgerNameDr</th>
            <th>Amount</th>
        
          </tr>
        </thead>
        <tbody>
          {DetailArr.map((item, index) => (
            <tr key={index}>
            
             
              <td>{item.LedgerNameCr}</td>
              <td>{item.LedgerNameDr}</td>
              <td>{item.Amount}</td>
     
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <div className="text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default PageList_PointsEntry;
